import { OneClickPurchaseEventCartObject, OneClickPurchaseEventTransactionObject } from "./typeDefinitions";

export class OneClickPurchaseEvent {
  event       : string;
  cart       ?: OneClickPurchaseEventCartObject = null;
  transaction?: OneClickPurchaseEventTransactionObject = null;

  constructor(event: string, cart: OneClickPurchaseEventCartObject, transaction: OneClickPurchaseEventTransactionObject) {
    this.event = event;
    this.cart = cart;
    this.transaction = transaction;

    if (!this.cart) {
      delete this.cart;
    }

    if (!this.transaction) {
      delete this.transaction;
    }
  }
}